import styled from "styled-components";

const MyDiv = styled.div`
  width: 100%;
  padding: 16px 24px;

  .top-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    flex-wrap: wrap;
    gap: 12px;
  }

  .search-box input {
    padding: 8px 12px;
    border: 1px solid #0051ca;
    border-radius: 6px;
    width: 250px;
  }

  .btn {
    background: rgba(30, 101, 241, 1);
    color: white;
    &:hover {
      background: rgba(15, 67, 209, 0.9);
      color: white;
    }
  }

  .add-btn:hover {
    background-color: #0d47a1;
  }

  .card_box {
    background: white;
    padding: 15px 10px;
    border-radius: 16px;
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.15));
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`;

export default MyDiv;
